const { h, render, Component } = require('preact');


class Recaptcha extends Component {
  constructor(props) {
    super(props);
    let lang = typeof window !== "undefined" && (window.recaptchaOptions && window.recaptchaOptions.lang) ? `&hl=${window.recaptchaOptions.lang}` : "";
	this.URL = `https://www.google.com/recaptcha/api.js?&onload=recaptchaLoaded&render=explicit${lang}`;
	this.waitingTimer = null;
	this.element = null;
	this.recaptchaId = null;
	this._captureRef = this.captureRef.bind(this);
	this._initializeRecaptcha = this.initializeRecaptcha.bind(this);
	this._handleExpired = this.handleExpired.bind(this);
	this._handleChange = this.handleChange.bind(this);
	this.clearTimer = this.clearTimer.bind(this);
	this.execute = this.execute.bind(this);
	this.initializeRecaptcha = this.initializeRecaptcha.bind(this);
	this.renderRecaptcha = this.renderRecaptcha.bind(this);
	this.reset = this.reset.bind(this);
	this.getResponse = this.getResponse.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.handleExpired = this.handleExpired.bind(this);
	this.removeRecaptcha = this.removeRecaptcha.bind(this);
	this.isRecaptchaJSLibInjected = this.isRecaptchaJSLibInjected.bind(this);
	this.startTimer = this.startTimer.bind(this);
	this.captureRef = this.captureRef.bind(this);
  }

    isRecaptchaLoaded() {
		return ((typeof window !== 'undefined') && (typeof window.grecaptcha !== 'undefined'));
	} 


	componentDidMount() {
		this.initializeRecaptcha();
    }

    
    componentWillUnmount() {
        this.clearTimer();
        if (this.isRecaptchaLoaded() && this.element && this.recaptchaId !== null) {
            this.removeRecaptcha();
        }
        if ( window.___grecaptcha_cfg ) {
            delete ___grecaptcha_cfg.clients[this.recaptchaId];
            ___grecaptcha_cfg.count--;
        }
    }


    render() {
        // eslint-disable-next-line no-unused-vars
        const { sitekey, onChange, theme, type, tabindex, onExpired, size, stoken, grecaptcha, badge, ...childProps } = this.props;
        return (
            <div {...childProps} ref={this._captureRef} />
        );
    }


    clearTimer()  {
		if (this.waitingTimer !== null) {
			clearInterval(this.waitingTimer);
        }
    }


    execute() {
    	if (this.isRecaptchaLoaded() && this.element && this.recaptchaId !== null && this.props.size === "invisible") {
            grecaptcha.execute(this.recaptchaId);
            return true;
        }
    	return false;
    }


    initializeRecaptcha() {
	    if (this.isRecaptchaLoaded()) {
	        // Initialize recaptcha
	        this.clearTimer();
	        this.renderRecaptcha();
	    } else if (!this.isRecaptchaJSLibInjected()) {
	        // Check if script already injected, if not load it async with callback
	        let script = document.createElement("script");
	        window.recaptchaLoaded = this.initializeRecaptcha.bind(this);
	        script.src = this.URL;
	        script.async = 1;
	        script.defer = 1;
	        script.onerror = () => {
	            console.log("Error loading google recaptcha!");
	        };
	        document.body.appendChild(script);
	    } else {
	        this.startTimer();
	    }
	}

	renderRecaptcha ()  {
        this.recaptchaId = grecaptcha.render(this.element, {
            sitekey: this.props.sitekey,
            callback: this._handleChange,
            theme: this.props.theme,
            type: this.props.type,
            tabindex: this.props.tabindex,
            "expired-callback": this._handleExpired,
            size: this.props.size,
            stoken: this.props.stoken,
            badge: this.props.badge
        });
    }


    reset () {
        if (this.isRecaptchaLoaded() && this.element && this.recaptchaId !== null) {
            grecaptcha.reset(this.recaptchaId);
            return true;
        }
        return false;
    }



    getResponse() {
        if (this.isRecaptchaLoaded() && this.element && this.recaptchaId !== null) {
            return grecaptcha.getResponse(this.recaptchaId);
        }
        return null;
    }


    handleChange(response) {
        if (this.props.onChange) {
            this.props.onChange(response);
        }
    }


    handleExpired() {
        if (this.props.onExpired) {
            this.props.onExpired();
        }
    }


    removeRecaptcha() {
        grecaptcha.reset(this.recaptchaId);
    }
        
    captureRef(elem)  {
        this.element = elem;
    }

    isRecaptchaJSLibInjected () {
        if (typeof window === 'undefined') { return false; }
        if (!document.scripts || document.scripts.length === 0) { return false; }
        let scripts = Object.assign([], document.scripts);
        return (scripts.filter((script) => {
            return script.src.match(/((http|https):)?\/\/(www\.)?google\.com\/recaptcha\/(.*)/i) !== null;
        })).length > 0;
    }


    startTimer() {
        this.waitingTimer = setTimeout(this._initializeRecaptcha, 200);
    }




}

module.exports = Recaptcha


Recaptcha.defaultProps = {
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};
